import { protectedGet } from "./restUtil";
import { PaymentMethod } from "../model/paymentMethod";
import { ListResponse } from "../model/response";

export function getPaymentMethods(): Promise<ListResponse<PaymentMethod>> {
  return new Promise((resolve, reject) => {
    protectedGet("/payment/methods", undefined, resolve, reject);
  });
}
